import { useContext, useEffect } from 'react'

import TenantContext from './context'

// Hook for managing the current tenant
const useApplyTenant = (tenant: string | null): void => {
  const { updateTenant } = useContext(TenantContext)

  useEffect(() => {
    updateTenant(tenant)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenant])
}

export default useApplyTenant
